export default __webpack_public_path__ + "static/media/green_gem.f0014e34.png";